import type React from "react"

import { TextCss } from "../../components/GlobalCss/TextCss"

interface CheckboxProps {
  isChecked?: boolean
  isDisabled?: boolean
  onChange?: (checked: boolean) => void
  label?: string
}

const Checkbox: React.FC<CheckboxProps> = ({
  isChecked = false,
  isDisabled = false,
  onChange,
  label
}) => {
  const handleChange = () => {
    if (isDisabled) return

    const newValue = !isChecked
    onChange?.(newValue)
  }

  return (
    <label className={`checkbox-container ${isDisabled ? "checkbox-disabled" : ""}`}>
      <input
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={handleChange}
        className="checkbox-input"
      />
      <span className={`checkbox-custom ${isChecked ? "checkbox-checked" : ""}`}>
        {isChecked && (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3L4.5 8.5L2 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </span>
      {label && <span className={TextCss.sub_heading_400_14}>{label}</span>}
    </label>
  )
}

export default Checkbox
